import {getNewCount} from '@/libs/helper'
export default {
    name: 'List',
    data() {
        return {
            getNewCount
        }
    },
    props: {
        list: {
            type: Object,
            default: () => {}
        },
        followList: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        setFavorite: {
            type: Function,
            default: () => {}
        },
        isEmbeddable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        /**
         * to convert ISO format date to normal
         * @param {*} date 
         */
        getDate (date) {
            if (date !== undefined) {
              let d = new Date(date)
              return ('0' + d.getDate()).slice(-2) + ' ' + d.toLocaleString('default', { month: 'long' }) + ' ' +  d.getFullYear()
            }
        }
    }
}